export default "__VITE_ASSET__BAehj5LD__"